export default "__VITE_PUBLIC_ASSET__30be32b3__"